const halfMaxiumDisplayRange = (maxDisplayRange: number) => {
  return (maxDisplayRange - 1) / 2
}

const isSelectedPageWithinCenterOfRange = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  const middleNumbers = []

  for (
    let i = halfMaxiumDisplayRange(maxDisplayRange) + 1;
    i <= totalPages - halfMaxiumDisplayRange(maxDisplayRange);
    i++
  ) {
    middleNumbers.push(i)
  }

  return middleNumbers.find(element => element === selectedPage) !== undefined
}

const totalPagesGreaterThanDisplayRange = (totalPages: number, maxDisplayRange: number) => {
  return totalPages > maxDisplayRange
}

const selectedPageAtEndOfTotalPages = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  return totalPages - selectedPage < halfMaxiumDisplayRange(maxDisplayRange)
}

const isSelectedPageNearEndOfLargeRange = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  return (
    totalPagesGreaterThanDisplayRange(totalPages, maxDisplayRange) &&
    selectedPageAtEndOfTotalPages(totalPages, selectedPage, maxDisplayRange)
  )
}

const isSelectedPageCenteredWithinALargeRange = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  return (
    totalPagesGreaterThanDisplayRange(totalPages, maxDisplayRange) &&
    isSelectedPageWithinCenterOfRange(totalPages, selectedPage, maxDisplayRange)
  )
}

export const getPaginationEndNumber = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  const totalPagesLessThanDisplayRange = totalPages < maxDisplayRange

  if (
    totalPagesLessThanDisplayRange ||
    isSelectedPageNearEndOfLargeRange(totalPages, selectedPage, maxDisplayRange)
  ) {
    return totalPages
  }

  if (isSelectedPageCenteredWithinALargeRange(totalPages, selectedPage, maxDisplayRange)) {
    return selectedPage + halfMaxiumDisplayRange(maxDisplayRange)
  }

  return maxDisplayRange
}

export const getPaginationStartNumber = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  if (isSelectedPageNearEndOfLargeRange(totalPages, selectedPage, maxDisplayRange)) {
    return totalPages - (maxDisplayRange - 1)
  }

  if (isSelectedPageCenteredWithinALargeRange(totalPages, selectedPage, maxDisplayRange)) {
    return selectedPage - halfMaxiumDisplayRange(maxDisplayRange)
  }

  return 1
}

export const getPageNumbersArray = (
  totalPages: number,
  selectedPage: number,
  maxDisplayRange: number
) => {
  const paginationStartNumber = getPaginationStartNumber(totalPages, selectedPage, maxDisplayRange)

  const paginationEndNumber = getPaginationEndNumber(totalPages, selectedPage, maxDisplayRange)

  const pageNumbersArray = []

  for (let i = paginationStartNumber; i <= paginationEndNumber; i++) {
    pageNumbersArray.push(i)
  }

  return pageNumbersArray
}
